export default __webpack_public_path__ + "static/media/logo_text.cc3857ed.svg";